import { render } from "./SuratKeteranganView.vue?vue&type=template&id=af46b7ba&scoped=true&ts=true"
import script from "./SuratKeteranganView.vue?vue&type=script&lang=ts"
export * from "./SuratKeteranganView.vue?vue&type=script&lang=ts"

import "./SuratKeteranganView.vue?vue&type=style&index=0&id=af46b7ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af46b7ba"]])

export default __exports__